import { Navigate, useLocation } from "react-router-dom";
import authenticationService from "../services/authentication.service";

const PrivateRoute = ({ children }) => {
  const token = authenticationService.getTokenLocal();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/post-job" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
